export enum ESubscriptionStatus {
    ACTIVE = 'active',
    EXPIRED = 'expired',
    TRIAL = 'trial',
    PAYMENT_FAILED = 'payment_failed',
}

export enum ENotificationStatus {
    DANGER = 'danger',
    WARNING = 'warning',
    INFO = 'info',
    ACTION = 'action',
}

export enum EButtonNames {
    Subscribe = 'Subscribe',
    ChangePlan = 'ChangePlan',
    EditPaymentDetail = 'EditPaymentDetail',
    RequestCancellation = 'RequestCancellation',
}

export enum EActionType {
    SUBSCRIBE = 'subscribe',
    CHANGE_PLAN = 'change_plan',
    EDIT_PAYMENT_DETAILS = 'edit_payment_details',
    REQUEST_CANCELLATION = 'cancel',
}

export enum EActionStatus {
    ENABLED = 'enabled',
    DISABLED = 'disabled',
}
